module.exports = "<select class=\"w3-select w3-block w3-border w3-round\"\r\n  [(ngModel)]=\"value\"\r\n  [disabled]=\"isDisabled\">\r\n  <option [value]=\"null\">Select shipping line</option>\r\n  <option *ngFor=\"let s of shippingLines\" [value]=\"s.key\">{{s.value}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-shipping-line-select/ztsi-shipping-line-select.component.html
// module id = ./src/app/components/shared/ztsi-shipping-line-select/ztsi-shipping-line-select.component.html
// module chunks = main